export default __webpack_public_path__ + "static/media/dash-monster.2187648a.svg";